import { schema } from "normalizr";

// const byIdSchema = new schema.Entity("byId", {}, { idAttribute: "campaignId" });
const byIdSchema = new schema.Entity("byId", {}, {});
export const byIdSchemaList = new schema.Array(byIdSchema);
